import React from "react";

function DiagonalRightArrowIcon() {
  return (
    <svg
      className="stroke-svg"
      width="100%"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.873535 9L8.91951 1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.873535 1H8.91951V9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DiagonalRightArrowIcon;
